// var migrate_ip = "http://172.16.100.33:8007/"

// var migrate_ip="http://172.16.100.33:8007/"
// var wechatUrl = 'wss://172.16.100.33:8007/ws'
// var fileUrl = 'https://172.16.100.33:8007/api/Inspection/WechatSericeFile'

var migrate_ip = "https://www.shooinsupport.com:6080/";
var wechatUrl = "wss://wechat.shooinsupport.com:10730/ws";
var fileUrl =
  "https://wechat.shooinsupport.com:10730/api/Inspection/WechatSericeFile";
var infoUrl = "ws://wechatapi.shooinsupport.com:6080/ws";

let production = 2;

if (production == 1) {
  migrate_ip = "http://192.168.1.206:8001/";
  wechatUrl = "ws://192.168.1.66:10730/ws";
  fileUrl = "http://192.168.1.66:10730/api/Inspection/WechatSericeFile";
  infoUrl = "ws://192.168.1.66:8001/ws";
} else if (production == 2) {
  migrate_ip = "http://172.16.100.33:8007/";
  wechatUrl = "wss://172.16.100.33:8007/ws";
  fileUrl = "https://172.16.100.33:8007/api/Inspection/WechatSericeFile";
  infoUrl = "ws://172.16.100.33:8007/ws";
}
